import { render } from "./uploaSoAprotocol.vue?vue&type=template&id=7047d7d2&scoped=true"
import script from "./uploaSoAprotocol.vue?vue&type=script&lang=js"
export * from "./uploaSoAprotocol.vue?vue&type=script&lang=js"

import "./uploaSoAprotocol.vue?vue&type=style&index=0&id=7047d7d2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7047d7d2"]])

export default __exports__